import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem,
    Grid, Tabs, Tab, AppBar, Divider } from '@material-ui/core';
import { } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { Chart }  from 'chart.js';
import {Bar, Line, Pie, Doughnut} from 'react-chartjs-2';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';
import { isNullOrUndefined } from 'util';



//THEME STYLER
const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    tabBar: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
})


//FOR DYNAMIC TABS
function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };

//CONSTRUCTOR
class studentDash extends Component{
    constructor(props){
        super(props)
        this.state = {
            subjects: [],
            averages: [{myAverages: []}, {classAverages: []}],
            testAverages: [{myAverages: []}, {classAverages: []}],
            value: 0,
            punctuality: [],
            testsBySubject: [],
            tagList: [],
            graphData: [],
            testGraphData: [],
            bestTag: {tag: '', score: 0},
            worstTag: {tag: '', score: 0},
            targetGrade: 0,
        }
    }


    //COMPONENT DID MOUNT - GRABS DATA FROM DB
    componentDidMount(){
        const studentID = sessionStorage.getItem('uid')
        const allTestsSetRef = db.collection('AssignedTasks').orderBy('Deadline', 'asc')
        var allTagsForTestsTaken = [] 
        var allTestsSet = []
        var allTestsToMe = [] 
        var completionCount  = 0
        var punctuality = [] 
        var classAvgs = [] 
        var allTestScores = [] 
        var myTestScores = [] 
        var tags = []
        var testsBySubj = []
        
        db.collection('Users').where('UID', '==', studentID).get()
                .then(snapshot => {
                    snapshot.forEach(user => {
                        this.setState({
                            targetGrade: user.data().target
                        })
                        
                    })
                })

        allTestsSetRef.get()
            .then(snapshot => { 
                snapshot.docs.forEach(doc => {
                    var classTotal = 0 
                    allTestsSet.push({test: doc.id, data: doc.data()})
                    doc.data().AssignedTo.forEach(student => {
                       if (student.Student == studentID) { 
                           if (student.CompletionDate != 'N/A') {
                                allTestsToMe.push({test: doc.id, data: doc.data()}) 
                               completionCount = completionCount + 1
                               punctuality.push({test: doc.id, data: student.punctuality, perQ: student.perQuestion, subject: doc.data().Subject})
                           }
                           if (student.Score) { 
                               allTestScores.push(student.Score)
                           }
                       }
                   }) 
                })
                //DEBUG LINE
                // console.log(allTagsForTestsTaken, allTestsSet, allTestsToMe, completionCount, punctuality, allTestScores)
                var holdingArr = []
                punctuality.forEach(test => {
                    test.perQ.forEach(Q => {
                        Q.tags.forEach(tag => { 
                            var value = 0
                            if (Q.result == true){value = 1}
                            var obj = {subject: test.subject, tag: tag, value: value}
                            holdingArr.push(obj)
                        })
                    })
                })
                console.log(holdingArr)

                holdingArr.forEach(questionObj => {
                    if (allTagsForTestsTaken.length == 0) {
                        var obj = {subject: questionObj.subject, tags: [{tag: questionObj.tag, count: 1, value: questionObj.value}]  }
                        allTagsForTestsTaken.push(obj)
                        return
                    } else {
                        for (let i = 0; i < allTagsForTestsTaken.length; i++) {
                            if (allTagsForTestsTaken[i].subject == questionObj.subject) {
                            // allTagsForTestsTaken[i].tags = allTagsForTestsTaken[i].tags.concat(questionObj.tags)
                                for (let j = 0; j < allTagsForTestsTaken[i].tags.length; j++){
                                    if (allTagsForTestsTaken[i].tags[j].tag == questionObj.tag) {
                                        allTagsForTestsTaken[i].tags[j].count = allTagsForTestsTaken[i].tags[j].count + 1
                                        allTagsForTestsTaken[i].tags[j].value = allTagsForTestsTaken[i].tags[j].value + questionObj.value
                                        return
                                    } else if (allTagsForTestsTaken[i].tags.indexOf(allTagsForTestsTaken[i].tags[j]) == allTagsForTestsTaken[i].tags.length -1) {
                                        var obj = [{tag: questionObj.tag, count: 1, value: questionObj.value}]
                                        allTagsForTestsTaken[i].tags = allTagsForTestsTaken[i].tags.concat(obj)
                                        return
                                    }
                                }
                            } else if (allTagsForTestsTaken.indexOf(allTagsForTestsTaken[i])  == allTagsForTestsTaken.length -1){
                                var obj = {subject: questionObj.subject, tags: [{tag: questionObj.tag, count: 1, value: questionObj.value}]  }
                                allTagsForTestsTaken.push(obj)
                                return
                            }
                        }
                    }
                })
                
                console.log(allTagsForTestsTaken)

              
                this.setState({
                    testsBySubj: testsBySubj,
                    tagData: allTagsForTestsTaken,
                    tagList: tags,
                    completionCount: completionCount,
                    punctuality: punctuality,
                    allTestScores: allTestScores,
                    allTestsSet: allTestsSet,
                    allTestsToMe: allTestsToMe,
                })
                this.postFetch(testsBySubj, allTestsToMe)
                this.TagData2(this.state.value)
                
            })

            


    }

//-------------------------------------------------------------------------------------------------------//

    postFetch = (subjects, testsToMe) => {
        var subjectArr = subjects
        var sortedTests = [] 
        const testsTaken =  testsToMe
        // console.log(this.state, testsTaken)
        testsTaken.forEach(testTaken => { 
            // console.log(testTaken.data.Subject)
            const thisTestSubj = testTaken.data.Subject
            if (!subjectArr.includes(thisTestSubj)) { 
                subjectArr.push(thisTestSubj)
                sortedTests.push({
                    subject: thisTestSubj,
                    tests: [testTaken]
                })
            } else {
                console.log('new subject', testTaken)
                sortedTests.forEach(list => {
                    if (list.subject == thisTestSubj){
                        list.tests = list.tests.concat(testTaken)
                    }
                })
            }
        })
        this.setState({
            subjects: subjectArr,
            testsBySubject: sortedTests
        })
        // console.log(subjectArr, sortedTests)
        sortedTests.forEach(subj => { 
            this.getPersonalAvgScore(subj)
        })
        if (sortedTests.length > 0) {
            // console.log(sortedTests[this.state.value].subject, sortedTests)
            this.subjProgress(sortedTests[this.state.value].subject, sortedTests)
        }
        
    }
//-------------------------------------------------------------------------------------------------------//
    getPersonalAvgScore = (obj) => {
        console.log('GET PERSONAL AVG', obj)
        var obj2 = {subject: '', tests: []}
        var testsObj = {subject: '', tests: []}
        var tests = []
        var classTests = []
        var count = 0
        var classCount = 0
        var runningTotal = 0
        var classRunningTotal = 0
        var avg = 0 
        var testAvg = 0 
        var classAvg = 0 
        var classTestAvg = 0
        var bestAvg = 0
        var bestTestAvg = 0
        var bestClassAvg = 0
        var bestIndex = 0 
        var myobj= {}
        var classobj = {}
        var myAvgArr = this.state.averages[0].myAverages
        var classAvgArr = this.state.averages[1].classAverages
        var myTestAvgArr = this.state.testAverages[0].myAverages
        var classTestAvgArr = this.state.testAverages[1].classAverages
        obj.tests.forEach(test => { 
            if (test.data.Test === false) {
                obj2.subject = obj.subject
                obj2.tests = obj2.tests.concat(test)
            } else {
                testsObj.subject = obj.subject
                testsObj.tests = testsObj.tests.concat(test)  
            }
        })

        obj2.tests.forEach(test => {
            test.data.AssignedTo.forEach(member => { 
                console.log(member.Student)
                if (member.Student == sessionStorage.getItem('uid')) { 
                    count = count + 1
                    runningTotal = runningTotal + member.Score
                    tests.push({test: test.test, score: member.Score})
                    classCount = classCount + 1
                    classRunningTotal = classRunningTotal + member.Score
                } else { 
                    if (member.CompletionDate != 'N/A'){
                        classCount = classCount + 1
                        classRunningTotal = classRunningTotal + member.Score
                    }
                }
            })
            classTests.push({test: test.test, score: classRunningTotal/classCount})
        })
        classAvg = classRunningTotal/classCount
        avg = runningTotal/count
        if (avg > bestAvg){ 
            bestAvg = avg
            bestIndex = this.state.subjects.indexOf(obj.subject)
        }
        // console.log('avg', avg)
        // console.log(this.state.averages[0].myAverages)
        myobj = {subject: obj.subject, avg: avg, peak: 0, tests: tests}
        classobj = {subject: obj.subject, avg: classAvg, peak: 0, tests: classTests}
        myAvgArr = myAvgArr.concat(myobj)
        classAvgArr = classAvgArr.concat(classobj)
        this.setState({
            averages: [{myAverages : myAvgArr}, {classAverages: classAvgArr}],
            value : bestIndex

        })
        console.log(this.state.averages)
        this.buildData2(obj.subject, myobj, classobj, 'homework' )
        tests = []
        classTests = []
        count = 0
        classCount = 0
        runningTotal = 0
        classRunningTotal = 0

        testsObj.tests.forEach(test => {
            test.data.AssignedTo.forEach(member => { 
                console.log(member.Student)
                if (member.Student == sessionStorage.getItem('uid')) { 
                    count = count + 1
                    runningTotal = runningTotal + member.Score
                    tests.push({test: test.test, score: member.Score})
                    classCount = classCount + 1
                    classRunningTotal = classRunningTotal + member.Score
                } else { 
                    if (member.CompletionDate != 'N/A'){
                        classCount = classCount + 1
                        classRunningTotal = classRunningTotal + member.Score
                    }
                }
            })
            classTests.push({test: test.test, score: classRunningTotal/classCount})
            console.log('CLASS COUNT', classCount)
        })
        classTestAvg = classRunningTotal/classCount
        testAvg = runningTotal/count
        if (testAvg > bestTestAvg){ 
            bestTestAvg = testAvg
            bestIndex = this.state.subjects.indexOf(obj.subject)
        }
        // console.log('avg', avg)
        // console.log(this.state.averages[0].myAverages)
        myobj = {subject: obj.subject, avg: testAvg, peak: 0, tests: tests}
        classobj = {subject: obj.subject, avg: classTestAvg, peak: 0, tests: classTests}
        myTestAvgArr = myTestAvgArr.concat(myobj)
        classTestAvgArr = classTestAvgArr.concat(classobj)
        this.setState({
            testAverages: [{myAverages : myTestAvgArr}, {classAverages: classTestAvgArr}],
            value : bestIndex

        })
        console.log(this.state.testAverages)
        this.buildData2(obj.subject, myobj, classobj, 'test' )


        
    }

//-------------------------------------------------------------------------------------------------------//

buildData2 = (subject, myObj, classObj, type) => { 
    var labelArr = []
    var myScoreArr = [] 
    var classScoreArr = []
    var targetScoreArr = []  
    var graphData = this.state.graphData
    var testGraphData = this.state.testGraphData

    myObj.tests.forEach(test => {
        labelArr.push(test.test)
        myScoreArr.push(test.score)
    })

    classObj.tests.forEach(test => { 
        classScoreArr.push(test.score)
    })

    myScoreArr.forEach(score => { 
        targetScoreArr.push(this.state.targetGrade)
    })

    console.log(labelArr, myScoreArr, targetScoreArr, classScoreArr)

    var myData = {
        label: 'My performance',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: 'rgba(75,192,192,1)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: myScoreArr
    }

    var classData = {
        label: 'Class performance',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(215, 40, 40, 0.4)',
        borderColor: 'rgba(215, 40, 40, 1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(215, 40, 40, 1)',
        pointBackgroundColor: 'rgba(215, 40, 40, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(215, 40, 40, 1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: classScoreArr
    }
    
    var targetData = {
        label: 'Personal Target',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgb(127, 63, 191, 0.4)',
        borderColor: 'rgb(127, 63, 191, 0.4)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(127, 63, 191, 1)',
        pointBackgroundColor: 'rgba(127, 63, 191, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(127, 63, 191, 1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: targetScoreArr
    }
    var obj = {
        labels: labelArr,
        datasets: [myData,classData, targetData]
    }

    if ( type == 'homework'){
        graphData.push(obj)
    } else {
        testGraphData.push(obj)
    }
    

    if ( type == 'homework'){
        console.log(graphData)
        this.setState({
            graphData: graphData
        })
    } else {
        console.log(testGraphData)
        this.setState({
            testGraphData: testGraphData
        })
    }
    
}
//-------------------------------------------------------------------------------------------------------//
    tabHandleChange = (event, value) => {
        this.setState({ value });
        this.TagData2(value)
    };

//-------------------------------------------------------------------------------------------------------//
    TagData2 = (value) => {
       var tags = this.state.tagData
       var theseTags
       var bestTag
       var worstTag
       const currentSubj = this.state.subjects[value]
       console.log(currentSubj, this.state.value)
       if (tags) {
            tags.forEach(subj => {
                if(subj.subject == currentSubj) {
                    theseTags = subj
                    return
                }
            })
        }
        if (theseTags != undefined) {
            theseTags.tags.forEach(tag => {
                var thisAvg = (tag.value/tag.count)
                thisAvg = (Math.round(thisAvg * 100))
                if (bestTag == undefined) {
                    var obj = {tag: tag.tag, count: tag.count, value: tag.value, score: thisAvg} 
                    bestTag = obj
                    worstTag = obj
                } else {
                    if (bestTag.score < thisAvg) {
                        var obj = {tag: tag.tag, count: tag.count, value: tag.value, score: thisAvg} 
                        bestTag = obj
                    }
                    if (worstTag.score > thisAvg) {
                        var obj = {tag: tag.tag, count: tag.count, value: tag.value, score: thisAvg} 
                        worstTag = obj
                    }
                }
            })
        }
       this.setState({bestTag: bestTag, worstTag: worstTag})
    } 
//-------------------------------------------------------------------------------------------------------//
    doughnutDataStrong = () => {
        if (this.state.tagData) {
            const currentSubj = this.state.subjects[this.state.value]
            var labels = [] 
            var data = [] 
            var tagSet = []
            var tagLabel = []
            var holder = JSON.parse(JSON.stringify(this.state.tagData))
            holder.map(subject => { 
                if (subject.subject == currentSubj){
                    tagSet = subject.tags
                }
            })

            if ( tagSet.length >= 5 ) {
                tagSet.forEach(tag => { 
                    var obj  = { tag: tag.tag, value: Math.round((tag.value/tag.count)*100),}
                    tagLabel.push(obj)
                })
                tagLabel = tagLabel.sort(this.compareStrong)
                // console.log(tagLabel, 'TAG LABEL')
                tagLabel.splice(0,5).forEach(tag => { 
                    labels.push(tag.tag)
                    data.push(tag.value)
                })
            } else {
                tagSet.forEach(tag => { 
                    labels.push(tag.tag)
                    data.push(Math.round((tag.value/tag.count)*100))
                })
            }

            return {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#f9541f',
                    '#3748AC'
                    ],
                    hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#f9541f',
                    '#3748AC'
                    ]
                }]
            }
        }
    };

    doughnutDataWeak = () => {
        if (this.state.tagData) {
            const currentSubj = this.state.subjects[this.state.value]
            var labels = [] 
            var data = [] 
            var finalData = []
            var tagSet = []
            var tagLabel = []
            var holder = JSON.parse(JSON.stringify(this.state.tagData))
            holder.map(subject => { 
                if (subject.subject == currentSubj){
                    tagSet = subject.tags
                }
            })
            

            if ( tagSet.length >= 5 ) {
                tagSet.forEach(tag => { 
                    var obj  = { tag: tag.tag, value: Math.round((tag.value/tag.count)*100),}
                    tagLabel.push(obj)
                })
                tagLabel = tagLabel.sort(this.compareWeak)
                // console.log(tagLabel, 'TAG LABEL')
                tagLabel.splice(0,5).forEach(tag => { 
                    labels.push(tag.tag)
                    data.push(tag.value)
                })
            } else {
                tagSet.forEach(tag => { 
                    labels.push(tag.tag)
                    data.push((100 - Math.round((tag.value/tag.count)*100)))
                })
            }

            data.forEach(score => { 
                finalData.push(100 - score)
            })
            
            console.log(data, finalData, 'CHANGES')

            return {
                labels: labels,
                datasets: [{
                    data: finalData,
                    backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#f9541f',
                    '#3748AC'
                    ],
                    hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#f9541f',
                    '#3748AC'
                    ]
                }]
            }
        }
    };
    

    compareStrong(a, b) {
        let comparison = 0;
        if (a.value < b.value) {
          comparison = 1;
        } else if (a.value > b.value) {
          comparison = -1;
        }
        return comparison;
    }

    compareWeak(a, b) {
        let comparison = 0;
        if (a.value > b.value) {
          comparison = 1;
        } else if (a.value < b.value) {
          comparison = -1;
        }
        return comparison;
    }

//-------------------------------------------------------------------------------------------------------//

subjProgress = async (subject, data) => {
    console.log('WERE CONCERNED WITH', subject)
    var subjectSections = []
    var theseSections = []
    var output = []
    var theseTests = data[this.state.value].tests
    var example = theseTests[0].data
    var ref = await db.collection('Level').doc(example.Level).collection('Subjects').doc(example.Subject).collection('Years').doc(example.Year).collection('Abilities').doc(example.Ability).get()
    
    subjectSections = ref.data().data.Content.Sections
    // console.log(snapshot.data())
    theseTests.forEach(test => {
        var Section = test.data.Section
        if (theseSections.length == 0){ 
            theseSections = [Section]
        } else
        if (!theseSections.includes(Section)) {
            theseSections.push(Section)
        } 
    })
    console.log(subjectSections.length, theseSections.length, Math.round((theseSections.length/subjectSections.length)*100/100))
    this.setState({
        progressPercent: Math.round((theseSections.length/subjectSections.length)*100),
        progressTotal: subjectSections.length,
        progressSoFar: theseSections.length
    })
    return {
        progressPercent: Math.round((theseSections.length/subjectSections.length)*100),
        progressTotal: subjectSections.length,
        progressSoFar: theseSections.length
    }
}



    render(){
        const { classes } = this.props; 
        const {value} = this.state;
        return (
            <div>
                <Paper className={classes.root} elevation={1}>
                    <Grid container spacing={24}>
                        {this.state.bestTag ? 
                            <Grid item md={6} xs={12}>
                                <Paper className={classes.paper} elevation={1}>
                                    <Typography variant='title'>
                                        Strongest Areas
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    <Typography variant='subheading'>
                                    Strongest performance: {this.state.bestTag.score}%
                                    <br/>
                                    Strongest Area : {this.state.bestTag.tag}
                                    </Typography>
                                    <Divider/>
                                    <Doughnut data={this.doughnutDataStrong()} />
                                </Paper>
                            </Grid>
                        :
                            <div/>
                        }
                        
                        
                        <Grid item md={6} xs={12}>
                            {/* <Typography variant='healdine'>
                                {JSON.stringify(this.state.averages[0].myAverages[0]) + ' vs ' + JSON.stringify(this.state.averages[0].myAverages[1])}
                            </Typography> */}
                            {this.state.testAverages[0].myAverages[0] && this.state.testAverages[0].myAverages[0].tests.length > 0 ? 
                            <div className={classes.tabBar}>
                                <AppBar position='static'>
                                    <Tabs value={value} onChange={this.tabHandleChange}>
                                        {this.state.testAverages[0].myAverages.map(subj => {
                                            return <Tab label={subj.subject}/>
                                        })}
                                    </Tabs>
                                </AppBar>
                                {/* {value === index && <TabContainer>{subj.avg}</TabContainer>} */}
                                {this.state.testAverages[0].myAverages.map(subj => { 
                                    const index = this.state.testAverages[0].myAverages.indexOf(subj)
                                    return value === index && <TabContainer>
                                        <div>
                                            <Typography variant='subheading'>
                                                Your Average Test score: {Math.round(subj.avg * 100)/100}%
                                            </Typography>
                                            <Divider/>
                                            <br/>
                                           <Line data={this.state.testGraphData[this.state.value]}/>
                                        </div>
                                        </TabContainer>
                                })}
                            </div>
                            :
                            <Paper className={classes.paper} elevation={1}>
                                <Typography variant='title'>
                                    You Don't Have Test Data
                                </Typography>
                                <Divider/>
                                <br/>
                                <Typography variant='subheading'>
                                    Visit 'Tasks' to see if you have any outstanding
                                </Typography>
                            </Paper>
                            }
                        </Grid>
                        
                        {this.state.worstTag ?
                            <Grid item md={6} xs={12}>
                                <Paper className={classes.paper} elevation={1}>
                                    <Typography variant='title'>
                                        Development Areas
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    <Typography variant='subheading'>
                                    Performance to be most imporoved: {this.state.worstTag.score}%
                                    <br/>
                                    Needs the most work : {this.state.worstTag.tag}
                                    </Typography>
                                    <Divider/>
                                    <Doughnut data={this.doughnutDataWeak()} />
                                </Paper>
                            </Grid>
                        :
                            <div/>
                        }
                        
                        <Grid item md={6} xs={12}>
                            {/* <Typography variant='healdine'>
                                {JSON.stringify(this.state.averages[0].myAverages[0]) + ' vs ' + JSON.stringify(this.state.averages[0].myAverages[1])}
                            </Typography> */}
                            {this.state.averages[0].myAverages.length > 0 ? 
                            <div className={classes.tabBar}>
                                <AppBar position='static'>
                                    <Tabs value={value} onChange={this.tabHandleChange}>
                                        {this.state.averages[0].myAverages.map(subj => {
                                            return <Tab label={subj.subject}/>
                                        })}
                                    </Tabs>
                                </AppBar>
                                {/* {value === index && <TabContainer>{subj.avg}</TabContainer>} */}
                                {this.state.averages[0].myAverages.map(subj => { 
                                    const index = this.state.averages[0].myAverages.indexOf(subj)
                                    return value === index && <TabContainer>
                                        <div>
                                            <Typography variant='subheading'>
                                                Your Average Homework score: {Math.round(subj.avg * 100)/100}%
                                            </Typography>
                                            <Divider/>
                                            <br/>
                                           <Line data={this.state.graphData[this.state.value]}/>
                                        </div>
                                        </TabContainer>
                                })}
                            </div>
                            :
                            <Paper className={classes.paper} elevation={1}>
                                <Typography variant='title'>
                                    You Don't Have Homework Data
                                </Typography>
                                <Divider/>
                                <br/>
                                <Typography variant='subheading'>
                                    Visit 'Tasks' to see if you have any outstanding
                                </Typography>
                            </Paper>
                            }
                        </Grid>
                        {this.state.testAverages[0].myAverages[0] && this.state.testAverages[0].myAverages[0].tests.length > 0 ? 
                            this.state.testAverages[0].myAverages.map(subject => { 
                                return (
                                    subject.tests.map(test => {
                                        return (
                                            <Grid item md={6} xs={12}>
                                                <Paper className={classes.paper} elevation={1}>
                                                    <Typography variant='title'>
                                                        {test.test}
                                                    </Typography>
                                                    <Divider/>
                                                    <br/>
                                                    <Typography variant='subheading'>
                                                        Subject: {subject.subject}
                                                        <br/>
                                                        Section: {this.state.testsBySubject[this.state.testsBySubj.indexOf(subject.subject)].tests.map(obj => { if (obj.test == test.test){return obj.data.Section} })}
                                                        <br/>
                                                        Result: {test.score}%
                                                        <br/>
                                                        {(this.state.testAverages[1].classAverages[this.state.testAverages[0].myAverages.indexOf(subject)].tests[subject.tests.indexOf(test)]) ?
                                                            'Class Average: ' + this.state.testAverages[1].classAverages[this.state.testAverages[0].myAverages.indexOf(subject)].tests[subject.tests.indexOf(test)].score +'%'
                                                        :   
                                                            'Class Average: ' + '%'
                                                        }
                                                        
                                                        <br/>
                                                        Target Grade: {this.state.targetGrade}%
                                                        <br/>
                                                    </Typography>
                                                    <Divider/>
                                                </Paper>
                                            </Grid>
                                        )
                                    })
                                )
                            })
                        :
                            <div/>
                        }
                        {this.state.testsBySubject[this.state.value] ? 
                        
                            <Grid item xs={12} >
                                <Paper className={classes.paper} elevation={1}>
                                    <Typography variant='title'>
                                        National Curriculum progress
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    {console.log(this.state)}
                                    {this.state.testsBySubject.map(subject => { 
                                        var punctuality = 0
                                        var count = 0
                                        if (this.state.subjects.indexOf(subject.subject) == this.state.value) { 
                                            subject.tests.forEach(test => {
                                                test.data.AssignedTo.forEach(student => { 
                                                    if (student.Student == sessionStorage.getItem('uid')) { 
                                                        count = count + 1
                                                        punctuality = punctuality + student.punctuality
                                                    }
                                                })
                                            })
                                            
                                        return (
                                            <div>
                                            <Typography variant='subheading'>
                                                Your work is done on average : {Math.round((punctuality/count) * 100/100)} days early
                                                <br/>
                                                Curriculum Progress: {this.state.progressPercent}%
                                                <br/>
                                                Total Sections: {this.state.progressTotal}
                                                <br/>
                                                Sections Covered: {this.state.progressSoFar}
                                            </Typography>
                                            </div>
                                        )}
                                    })}
                                </Paper>
                            </Grid>
                        :
                        <div/>
                            }
                    </Grid>
                </Paper>
            </div>
        )
    }
}
export default withStyles(styles)(studentDash);










//HOUSTON WE HAVE A PROBLEM NEED A RESET//
// import React, { Component } from 'react'; 
// import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem,
//     Grid, Tabs, Tab, AppBar, Divider } from '@material-ui/core';
// import { } from '@material-ui/icons';
// import PropTypes from 'prop-types';
// import { Chart }  from 'chart.js';
// import {Bar, Line, Pie, Doughnut} from 'react-chartjs-2';
// import creds from '../config/firebaseConfig';
// import db from '../config/firestoreConfig';
// import { isNullOrUndefined } from 'util';


// const data = {
//     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
//     datasets: [
//       {
//         label: 'My First dataset',
//         fill: false,
//         lineTension: 0.1,
//         backgroundColor: 'rgba(75,192,192,0.4)',
//         borderColor: 'rgba(75,192,192,1)',
//         borderCapStyle: 'butt',
//         borderDash: [],
//         borderDashOffset: 0.0,
//         borderJoinStyle: 'miter',
//         pointBorderColor: 'rgba(75,192,192,1)',
//         pointBackgroundColor: '#fff',
//         pointBorderWidth: 1,
//         pointHoverRadius: 5,
//         pointHoverBackgroundColor: 'rgba(75,192,192,1)',
//         pointHoverBorderColor: 'rgba(220,220,220,1)',
//         pointHoverBorderWidth: 2,
//         pointRadius: 1,
//         pointHitRadius: 10,
//         data: [65, 59, 80, 81, 56, 55, 40]
//       }
//     ]
// };


// const styles = theme => ({
//     root: {
//         ...theme.mixins.gutters(),
//         paddingTop: theme.spacing.unit * 2,
//         paddingBottom: theme.spacing.unit * 2,
//         margin: 'auto',
//         width: '75%',
//     },
//     paper: {
//         padding: theme.spacing.unit * 2,
//         textAlign: 'center',
//         color: theme.palette.text.secondary,
//     },
//     tabBar: {
//         flexGrow: 1,
//         width: '100%',
//         backgroundColor: theme.palette.background.paper,
//     },
// })

// function TabContainer(props) {
//     return (
//         <Typography component="div" style={{ padding: 8 * 3 }}>
//         {props.children}
//         </Typography>
//     );
// }

// TabContainer.propTypes = {
//     children: PropTypes.node.isRequired,
//   };

// class studentDash extends Component{
//     constructor(props){
//         super(props)
//         this.state = {
//             subjects: [],
//             averages: [{myAverages: []}, {classAverages: []}],
//             value: 0,
//             punctuality: [],
//             testsBySubject: [],
//             tagList: [],
//         }
//     }

//     componentDidMount(){
//         const studentID = sessionStorage.getItem('uid')
//         const allTestsSetRef = db.collection('AssignedTasks').orderBy('Deadline', 'asc')

//         var allTagsForTestsTaken = [] 
//         var allTestsSet = []
//         var allTestsToMe = [] 
//         var completionCount  = 0
//         var punctuality = [] 
//         var classAvgs = [] 
//         var allTestScores = [] 
//         var myTestScores = [] 
//         var tags = []
//         var testsBySubj = []
        
//         allTestsSetRef.get()
//             .then(snapshot => { 
//                 snapshot.docs.forEach(doc => {
//                     var classTotal = 0 
//                     allTestsSet.push({test: doc.id, data: doc.data()})
//                     doc.data().AssignedTo.forEach(student => {
//                        if (student.Student == studentID) { 
//                            allTestsSet.push(doc.data())
//                            if (student.CompletionDate != 'N/A') {
//                                 allTestsToMe.push({test: doc.id, data: doc.data()}) 
//                                completionCount = completionCount + 1
//                                punctuality.push({test: doc.id, data: student.punctuality, perQ: student.perQuestion})
//                            }
//                            if (student.Score) { 
//                                allTestScores.push(student.Score)
//                            }
//                        }
//                    }) 
//                 })
//                 //DEBUG LINE
//                 // console.log(allTagsForTestsTaken, allTestsSet, allTestsToMe, completionCount, punctuality, allTestScores)
//                 punctuality.forEach(test => {
//                     // console.log(test)
                    
//                     test.perQ.forEach(Q => { 
//                         // console.log(Q)
//                         if (Q.tags) {
//                         const length = allTagsForTestsTaken.length
                        
//                         allTagsForTestsTaken = allTagsForTestsTaken.concat(Q.tags)
//                         // console.log(length, Q)
//                         for (var i = 0; i < Q.tags.length; ++i){
//                             tags.push({Count: 0, Score: 0, Total: 0})
//                         }
//                     }
//                     })
//                 })
//                 //DEBUG LINE
//                 // console.log(allTagsForTestsTaken, tags)
//                 punctuality.forEach(test => { 
//                     test.perQ.forEach(Q => { 
                        
//                         if (Q.tags) {
//                             if (Q.tags.length > 0) {
//                                 // console.log(Q.tags)
//                                 Q.tags.forEach( tag => {
//                                     // console.log(tag, Q.result, allTagsForTestsTaken.indexOf(tag))
//                                     tags[allTagsForTestsTaken.indexOf(tag)].Count = tags[allTagsForTestsTaken.indexOf(tag)].Count + 1
//                                     if (Q.result == true){
//                                         tags[allTagsForTestsTaken.indexOf(tag)].Score = tags[allTagsForTestsTaken.indexOf(tag)].Score + 1
//                                     }
//                                 })
//                             }
//                         }
//                     })
//                 })
//                 // console.log(allTagsForTestsTaken, tags)
//                 this.setState({
//                     testsBySubj: testsBySubj,
//                     tagData: tags,
//                     tagList: allTagsForTestsTaken,
//                     completionCount: completionCount,
//                     punctuality: punctuality,
//                     allTestScores: allTestScores,
//                     allTestsSet: allTestsSet,
//                     allTestsToMe: allTestsToMe,
//                 })
//                 this.postFetch(testsBySubj, allTestsToMe)
//                 this.buildData('myGraph', allTestsToMe, allTestScores)
//             })

//     }

//     buildData = (setName, dataObj, scoreArr) => { 
//         var labelArr = []

//         dataObj.forEach(test => {
//             labelArr.push(test.test)
//         })
//         var obj = {
//             labels: labelArr,
//             datasets: [
//                 {
//                     label: 'My performance',
//                     fill: false,
//                     lineTension: 0.1,
//                     backgroundColor: 'rgba(75,192,192,0.4)',
//                     borderColor: 'rgba(75,192,192,1)',
//                     borderCapStyle: 'butt',
//                     borderDash: [],
//                     borderDashOffset: 0.0,
//                     borderJoinStyle: 'miter',
//                     pointBorderColor: 'rgba(75,192,192,1)',
//                     pointBackgroundColor: '#fff',
//                     pointBorderWidth: 1,
//                     pointHoverRadius: 5,
//                     pointHoverBackgroundColor: 'rgba(75,192,192,1)',
//                     pointHoverBorderColor: 'rgba(220,220,220,1)',
//                     pointHoverBorderWidth: 2,
//                     pointRadius: 1,
//                     pointHitRadius: 10,
//                     data: scoreArr
//                 }
//             ]
//         }

//         this.setState({
//             myData: obj
//         })
//     }


//     postFetch = (subjects, testsToMe) => {
//         var subjectArr = subjects
//         var sortedTests = [] 
//         const testsTaken =  testsToMe
//         // console.log(this.state, testsTaken)
//         testsTaken.forEach(testTaken => { 
//             // console.log(testTaken.data.Subject)
//             const thisTestSubj = testTaken.data.Subject
//             if (!subjectArr.includes(thisTestSubj)) { 
//                 subjectArr.push(thisTestSubj)
//                 sortedTests.push({
//                     subject: thisTestSubj,
//                     tests: [testTaken.data]
//                 })
//             } else {
//                 console.log('new subject', testTaken)
//                 sortedTests.forEach(list => {
//                     if (list.subject == thisTestSubj){
//                         list.tests = list.tests.concat(testTaken.data)
//                     }
//                 })
//             }
//         })
//         this.setState({
//             subjects: subjectArr,
//             testsBySubject: sortedTests
//         })
//         // console.log(subjectArr, sortedTests)
//         sortedTests.forEach(subj => { 
//             this.getPersonalAvgScore(subj)
//         })
//     }

//     getPersonalAvgScore = (obj) => {
//         var count = 0
//         var runningTotal = 0
//         var avg = 0 
//         var bestAvg = 0
//         var bestIndex = 0 
//         obj.tests.forEach(test => {
           
//             test.AssignedTo.forEach(member => { 
//                 if (member.Student == sessionStorage.getItem('uid')) { 
//                     count = count + 1
//                     runningTotal = runningTotal + member.Score
//                 }
//             })
           
//         })
//          avg = runningTotal/count
//          if (avg > bestAvg){ 
//                 bestAvg = avg
//                 bestIndex = this.state.subjects.indexOf(obj.subject)
//             }

//             // console.log('avg', avg)
//             // console.log(this.state.averages[0].myAverages)
//             var myAvgArr = this.state.averages[0].myAverages
//             myAvgArr = myAvgArr.concat({subject: obj.subject, avg: avg, peak: 0})
//             this.setState({
//                 averages: [{myAverages : myAvgArr}, {classAverages: this.state.averages[1]}],
//                 value : bestIndex

//             })
//             console.log(this.state.averages)
//     }

//     tabHandleChange = (event, value) => {
//         this.setState({ value });
//     };

//     createChart = () => {
//         var ctx = this.refs.myChart
            
//     }

//     TagData = () => {
//         var tags = this.state.tagList
//         var tagScores = this.state.tagData
//         var bestAvg = null
//         var bestTag = null
//         var worstTag = null

//         tags.forEach(tag => {
//             let index = tags.indexOf(tag)
//             var avg = tagScores[index].Score/tagScores[index].Count
//             if (!bestTag) {
//                 bestAvg = avg
//                 bestTag = tag
//             } else {
//                 if (bestAvg < avg) { 
//                     bestAvg = avg
//                     bestTag = tags[index]
//                 }
//             }
//         })

//         // return {tag: bestTag, score: bestAvg}
//         return {tag: bestTag, score: 75}
//     } 

//     doughnutData = () => {
//         return {
//             labels: ["Foretelling", "Non-literal communcation", "shakespeare", "Descriptors"],
//             datasets: [{
//                 data: [75, 50, 12, 29],
//                 backgroundColor: [
//                 '#FF6384',
//                 '#36A2EB',
//                 '#FFCE56',
//                 '#f9541f'
//                 ],
//                 hoverBackgroundColor: [
//                 '#FF6384',
//                 '#36A2EB',
//                 '#FFCE56',
//                 '#f9541f'
//                 ]
//             }]
//         }
//     };
    

//     render(){
//         const { classes } = this.props; 
//         const {value} = this.state;


        
       

//         return (
//             <div>
//                 <Paper className={classes.root} elevation={1}>
//                     <Grid container spacing={24}>
//                     <Grid item xs={12} >
//                             <Paper className={classes.paper} elevation={1}>
//                                 <Typography variant='title'>
//                                     General info
//                                 </Typography>
//                                 <Divider/>
//                                 <br/>
//                                 {console.log(this.state)}
//                                 {this.state.testsBySubject.map(subject => { 
//                                     var punctuality = 0
//                                     var count = 0
//                                     if (this.state.subjects.indexOf(subject.subject) == this.state.value) { 
//                                         subject.tests.forEach(test => {
//                                             test.AssignedTo.forEach(student => { 
//                                                 if (student.Student == sessionStorage.getItem('uid')) { 
//                                                     count = count + 1
//                                                     punctuality = punctuality + student.punctuality
//                                                 }
//                                             })
//                                         })
                                    
//                                     return (
//                                         <Typography variant='subheading'>
//                                             Work is done on average : {Math.round((punctuality/count) * 100/100)} days early
//                                         </Typography>
//                                     )}
//                                 })}
//                             </Paper>
//                         </Grid>
//                         <Grid item xs={12}>
//                             {/* <Typography variant='healdine'>
//                                 {JSON.stringify(this.state.averages[0].myAverages[0]) + ' vs ' + JSON.stringify(this.state.averages[0].myAverages[1])}
//                             </Typography> */}
//                             {this.state.averages[0].myAverages.length > 0 ? 
//                             <div className={classes.tabBar}>
//                                 <AppBar position='static'>
//                                     <Tabs value={value} onChange={this.tabHandleChange}>
//                                         {this.state.averages[0].myAverages.map(subj => {
//                                             return <Tab label={subj.subject}/>
//                                         })}
//                                     </Tabs>
//                                 </AppBar>
//                                 {/* {value === index && <TabContainer>{subj.avg}</TabContainer>} */}
//                                 {this.state.averages[0].myAverages.map(subj => { 
//                                     const index = this.state.averages[0].myAverages.indexOf(subj)
//                                     return value === index && <TabContainer>
//                                         <div>
//                                             <Typography variant='title'>
//                                                 Your Average score: {Math.round(subj.avg * 100)/100}%
//                                             </Typography>
//                                             <Divider/>
//                                             <br/>
//                                             {this.createChart()}
//                                            <Line data={this.state.myData}/>
//                                         </div>
//                                         </TabContainer>
//                                 })}
//                             </div>
//                             :
//                             <div/>}
//                         </Grid>
//                         <Grid item xs={6}>
//                             <Paper className={classes.paper} elevation={1}>
//                                 <Typography variant='title'>
//                                     Strong Area Breakdown
//                                 </Typography>
//                                 <Divider/>
//                                 <br/>
//                                 <Typography variant='subheading'>
//                                    Best performance: {this.TagData().score}%
//                                    <br/>
//                                    In : {this.TagData().tag}
//                                 </Typography>
//                                 <Divider/>
//                                 <Doughnut data={this.doughnutData()} />
//                             </Paper>
//                         </Grid>
//                         <Grid item xs={6}>
//                             <Paper className={classes.paper} elevation={1}>
//                                 <Typography variant='title'>
//                                     Weak Area Breakdown
//                                 </Typography>
//                                 <Divider/>
//                                 <br/>
//                                 <Typography variant='subheading'>
//                                    Worst performance: {this.TagData().score}%
//                                    <br/>
//                                    In : {this.TagData().tag}
//                                 </Typography>
//                                 <Divider/>
//                                 <Doughnut data={this.doughnutData()} />
//                             </Paper>
//                         </Grid>
//                     </Grid>
//                 </Paper>
//             </div>
//         )
//     }
// }
// export default withStyles(styles)(studentDash);


// WEBPACK FOOTER //
// ./src/Dashboards/studentDash.jsx